import { createAction } from 'redux-actions';

export const setCollapsibleCheckboxListLoading = createAction(
    'SET_COLLAPSIBLE_CHECKBOX_LIST_LOADING',
);
export const setCollapsibleCheckboxListError = createAction(
    'SET_COLLAPSIBLE_CHECKBOX_LIST_ERROR',
);
export const setCollapsibleCheckboxListLoaded = createAction(
    'SET_COLLAPSIBLE_CHECKBOX_LIST_LOADED',
);
export const toggleCheckboxListItem = createAction(
    'TOGGLE_COLLAPSIBLE_CHECKBOX_LIST_ITEM',
);
export const toggleMasterCheckboxItem = createAction(
    'TOGGLE_MASTER_CHECKBOX_ITEM',
);
export const resetCollapsibleCheckboxListData = createAction(
    'RESET_COLLAPSIBLE_CHECKBOX_LIST_DATA',
);
export const appendCollapsibleListData = createAction(
    'APPEND_COLLAPSIBLE_CHECKBOX_LIST_DATA',
);
export const appendCollapsibleListDataViaSocket = createAction(
    'APPEND_COLLAPSIBLE_CHECKBOX_LIST_DATA_VIA_SOCKET',
);
export const mergeCollapsibleListDataViaSocket = createAction(
    'MERGE_COLLAPSIBLE_CHECKBOX_LIST_DATA_VIA_SOCKET',
);
export const removeCollapsibleListDataViaSocket = createAction(
    'REMOVE_COLLAPSIBLE_LIST_DATA_VIA_SOCKET',
);
export const updateCollapsibleListDataViaSocket = createAction(
    'UPDATE_COLLAPSIBLE_LIST_DATA_VIA_SOCKET',
);

export const fetchCollapsibleCheckboxListData = (type, apiCall, dataFormatter, withoutLoading = false) => {
    return async (dispatch) => {
        !withoutLoading && dispatch(setCollapsibleCheckboxListLoading({type}));
        try {
            const response = await apiCall();
            //Format data if dataFormatter is provided
            const processedResponse = dataFormatter && typeof dataFormatter === 'function' ? dataFormatter(response, withoutLoading) : response;
            const actionToDispatch = withoutLoading ? appendCollapsibleListData : setCollapsibleCheckboxListLoaded;
            dispatch(actionToDispatch({type, response: processedResponse}));
        } catch (error) {
            dispatch(setCollapsibleCheckboxListError({type, error}));
        }
    }
};
